import { render } from "./KalaStore.vue?vue&type=template&id=55f8b00b"
import script from "./KalaStore.vue?vue&type=script&lang=js"
export * from "./KalaStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__